import { createContext, useContext, useMemo, ReactNode } from 'react';
import { IMplServiceClient } from '../api/IMplServiceClient';
import { MplServiceClientFactory } from '../api/MplServiceClientFactory';

export const MplServiceClientContext = createContext<IMplServiceClient | undefined>(undefined);

export function MplServiceClientProvider({ children }: { children: ReactNode }) {
  const client = useMemo<IMplServiceClient>(() => MplServiceClientFactory.createV2(), []);
  return (
    <MplServiceClientContext.Provider value={client}>{children}</MplServiceClientContext.Provider>
  );
}

export function useMplServiceClient(): IMplServiceClient {
  const context = useContext(MplServiceClientContext);
  if (!context) {
    throw new Error('useMplServiceClient must be used within MplServiceClientProvider');
  }
  return context;
}
